import { ToastrService } from 'ngx-toastr';
import { Component, OnInit } from '@angular/core';
import * as _ from 'underscore';
import { NgxSpinnerService } from 'ngx-spinner';
import { ContactNewComponent } from '../../CONTACT/contact-new/contact-new.component';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ActivatedRoute, Router } from '@angular/router';
import { ParamsService } from 'src/app/shared/services/params.service';
import { IButton, TranslateService } from '@devinforius/i-essentials';
import { ServicesService } from 'src/app/shared/services/services.service';
import { UsersService } from 'src/app/shared/services/users.service';
import { UserDto } from 'src/app/shared/interfaces/users';
import { ContactsService } from 'src/app/shared/services/contacts.service';
import { GroupsGlobalDto, ContactTypeDto, LowInformationContactDto } from 'src/app/shared/interfaces';
import { GetMailRecipientsUtils } from 'src/app/utils/getMailRecipients.utils';
import { ServiceChildParent, ServicesPTreeSelect } from 'src/app/shared/models/iCourrier/service';
import { ContactsGlobalService } from 'src/app/shared/services/contacts-global.service';
import { RecipientsService } from 'src/app/shared/services/recipients.service';
import { GroupsService } from 'src/app/shared/services/groups.service';
import { Cols } from 'src/app/shared/models/cols';
import { LowInformationContact } from 'src/app/shared/models/iContact/contact/low-information-contact';
import { GroupContactsForRecipient } from 'src/app/shared/models/iContact/contact/group-contacts';
import { RecipientModalOnCloseDatas } from 'src/app/shared/models/recipient-modal';
import { ITabs } from '@devinforius/i-navigation';
import { manageServicesSetAsTreeSelect, manageServicesToBeMerged } from 'src/app/shared/utils/manage-services-for-tree-select.utils';
import { UserContactForRecipientModal } from 'src/app/shared/models';
import { catchError, forkJoin, of } from 'rxjs';

@Component({
  selector: 'app-recipient-modal',
  templateUrl: './recipient-modal.component.html',
  styleUrls: ['./recipient-modal.component.scss'],
})
export class RecipientModalComponent implements OnInit {
  public cols: Cols[] = [
    {
      field: 'name',
      header: 'Nom',
      format: (value) => {
        return value ?? '';
      },
    },
  ];

  public titleButtonsLoading: IButton[] = [
    {
      text: 'cancel',
      styleClass: 'blue',
      click: () => {
        this.closeActionModal();
      },
    },
  ];
  public titleButtons: IButton[] = [
    {
      text: 'cancel',
      styleClass: 'blue',
      click: () => {
        this.closeActionModal();
      },
    },
    {
      text: 'addRecipient',
      styleClass: 'green',
      id: 'buttonAddUsersRecipient',
      click: () => {
        this.addUsers();
      },
    },
  ];
  public courrierID: number;
  public userLoaded: boolean = false;
  public typeContact: (ContactTypeDto & { label?: string; value?: number })[] = [];
  public selectedTabs: { value: string } = null;
  public recipientsNames: string[] = [];
  public destinatairesNamePresent: string = '';
  public courrierType: string = ''; //Type entrant, sortant, interne

  public users: UserContactForRecipientModal[] = [];
  public usersArray: UserContactForRecipientModal[] = [];
  public filteredUsers: UserContactForRecipientModal[] = [];

  public serviceParent: ServicesPTreeSelect[] = [];
  public servicesList: {
    label: string;
    value: number;
    id: number;
    parentId: number;
    name: string;
    key: string;
    selectable: boolean;
    children: [];
    description: string;
    email: string;
  }[] = [];
  public serviceArray: ServiceChildParent[] = [];
  public filteredServices: {
    label: string;
    value: number;
    parentId: number;
    name: string;
    key: string;
    selectable: boolean;
    children: [];
    description: string;
    email: string;
  }[] = [];

  public listOfGroups: GroupsGlobalDto[] = [];
  public groups: GroupContactsForRecipient[] = [];
  public filteredGroups: GroupContactsForRecipient[] = [];
  public groupsArray: GroupContactsForRecipient[] = [];

  public contacts: LowInformationContact[] = [];
  public contactArray: LowInformationContact[] = [];
  public filteredContacts: LowInformationContact[] = [];

  public freeRecipient: string = '';
  public freeRecipientPool: { id: string; name: string }[] = [];
  public freeRecipientArray: { id: string; name: string }[] = [];

  public searchTabs: ITabs[] = [];

  constructor(
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private dialogService: DialogService,
    public route: ActivatedRoute,
    public router: Router,
    public params: ParamsService,
    public config: DynamicDialogConfig,
    public ref: DynamicDialogRef,
    public translater: TranslateService,
    private servicesService: ServicesService,
    private usersService: UsersService,
    private contactsService: ContactsService,
    private recipientsService: RecipientsService,
    private contactsGlobalService: ContactsGlobalService,
    private groupsService: GroupsService
  ) { }

  ngOnInit(): void {
    this.setTitleButtons();
    if (this.config?.data) {
      this.courrierID = this.config.data.courrierID;
      this.userLoaded = false;
      this.getData();
      this.getServiceList().then(() => {
        this.getCurrentDestinataire();
      });
      this.contactArray = [];
      this.usersArray = [];
      this.serviceArray = [];
      this.groupsArray = [];
      this.freeRecipientPool = [];
      this.freeRecipientArray = [];
    }
  }

  private setTitleButtons(): void {
    this.titleButtons = this.titleButtons.map((button) => ({ ...button, text: this.translater.translate(button.text) }));
    this.titleButtons.find((button) => button.id === 'buttonAddUsersRecipient').text = this.translater.translate('recipients.addXRecipient', {
      amount: '0',
    });
  }

  private getAmountRecipientsTitle(): void {
    const amount =
      (this.contactArray?.length ?? 0) +
      (this.usersArray?.length ?? 0) +
      (this.serviceArray?.length ?? 0) +
      (this.groupsArray?.length ?? 0) +
      (this.freeRecipientArray?.length ?? 0);
    // Better stringify the amount to have less problems when translating it. Strings are better interpreted than numbers. 0 as a number is {{Object Object}}; 0 as a string is 0
    const amountString = amount.toString();
    this.titleButtons[1].text =
      amount > 1
        ? this.translater.translate('recipients.addXRecipients', { amount: amountString })
        : this.translater.translate('recipients.addXRecipient', { amount: amountString });
  }

  /**
   * Initialize all array of the component
   * 1 - get the connected user's info
   * 2 - retreive all town's contact
   * 3 - get all groups
   * 4 - merge all contact to fill the 'this.allContacts
   */
  getData(): void {
    sessionStorage.getItem('showModalDestinataire') == '1' ? (this.courrierType = 'S') : (this.courrierType = null);

    forkJoin({
      contactsGroups: this.groupsService.fetchGlobalGroups().pipe(
        catchError(() => {
          this.toastr.error(this.translater.translate('recipients.errorLoadingGroups'));
          return of(null);
        })
      ),
      contactTypes: this.contactsGlobalService.fetchContactTypes().pipe(
        catchError(() => {
          this.toastr.error(this.translater.translate('recipients.errorLoadingContactTypes'));
          return of(null);
        })
      ),
      contactSummary: this.contactsService.fetchContactsSummary('iCourrier').pipe(
        catchError(() => {
          this.toastr.error(this.translater.translate('recipients.errorLoadingContacts'));
          return of(null);
        })
      ),
      iAdminUsers: this.usersService.fetchUsersFromiAdmin().pipe(
        catchError(() => {
          this.toastr.error(this.translater.translate('recipients.errorLoadingUsers'));
          return of(null);
        })
      ),
    }).subscribe((value) => {
      this.listOfGroups = value.contactsGroups;
      this.formatContactsGroups(value.contactsGroups);
      this.formatContactsTypes(value.contactTypes);
      this.formatContacts(value.contactSummary);
      this.formatIAdminUsers(value.iAdminUsers);
      this.getTabItems();
      this.userLoaded = true;
    });
  }

  private formatContactsGroups(contactGroups: GroupsGlobalDto[]): void {
    this.groups = contactGroups.map((group) => {
      return {
        ...group,
        name: group.description,
        type: 'GROUPE',
      };
    });
  }

  private formatContacts(contactSummary: LowInformationContactDto[]): void {
    this.contacts = contactSummary.map((contact) => new LowInformationContact(contact));
    this.contacts = this.contacts.filter((x) => x.userId === null);
  }

  private formatContactsTypes(contactTypes: ContactTypeDto[]): void {
    const mappedResponse: (ContactTypeDto & { label?: string; value?: number })[] = [...contactTypes];
    mappedResponse.map((typeContact) => {
      typeContact.label = typeContact.typeContact;
      typeContact.value = typeContact.id;
    });
    this.typeContact = contactTypes;
  }

  private formatIAdminUsers(users: UserDto[]): void {
    this.users = [];

    users.forEach((item) => {
      this.users.push({
        name: `${item.contactForUser.prenom ?? ''} ${item.contactForUser.nom ?? ''}`,
        label: `${item.contactForUser.prenom ?? ''} ${item.contactForUser.nom ?? ''}`,
        nom: `${item.contactForUser.nom ?? ''}`,
        prenom: `${item.contactForUser.prenom ?? ''}`,
        typeContactID: item.contactForUser.contactId,
        id: item.contactForUser.contactId,
        value: item.contactForUser.contactId,
        userId: item.userId,
        isUser: true,
        active: item.active,
      });
    });
  }

  getServiceList(): Promise<boolean> {
    return new Promise((resolve) => {
      this.servicesService.fetchMappedServicesToPrimeNGDropdowns().subscribe({
        next: (response) => {
          const datasForService = manageServicesSetAsTreeSelect(response, this.translater);
          this.serviceParent = datasForService.servicesForSingleCheck;
          this.servicesList = manageServicesToBeMerged(response);
          resolve(true);
        },
        error: (error) => {
          console.error('Error : ', error);
        },
      });
    });
  }

  getCurrentDestinataire(): void {
    const courrierId = sessionStorage.getItem('courrierID') ? +sessionStorage.getItem('courrierID') : this.courrierID;
    GetMailRecipientsUtils.getMailRecipients(
      courrierId,
      this.servicesList,
      this.recipientsService,
      this.contactsService,
      this.contactsGlobalService,
      this.listOfGroups
    ).subscribe({
      next: (response) => {
        if (response.error) {
          this.spinner.hide();
          this.toastr.error(this.translater.translate(response.error));
        } else {
          response.serviceList.map((item) => {
            item.name = item.name + ' ( Service )';
          });
          let tempDestinataire = response.userList.concat(response.freeList, response.serviceList, response.groupList);
          tempDestinataire = _.sortBy(tempDestinataire, 'name');

          this.recipientsNames = [];
          tempDestinataire.map((item) => {
            this.recipientsNames.push(item.name);
          });
          this.recipientsNames = _.uniq(this.recipientsNames);
          this.destinatairesNamePresent = _.uniq(this.recipientsNames).join(', ');
        }
      },
    });
  }
  public onChangeContacts(event: LowInformationContact[]): void {
    this.contactArray = event;
    this.getAmountRecipientsTitle();
  }
  public onChangeServices(event: ServiceChildParent[]): void {
    this.serviceArray = event;
    this.getAmountRecipientsTitle();
  }
  public onChangeGroups(event: GroupContactsForRecipient[]): void {
    this.groupsArray = event;
    this.getAmountRecipientsTitle();
  }
  public onChangeUsers(event: UserContactForRecipientModal[]): void {
    this.usersArray = event;
    this.getAmountRecipientsTitle();
  }
  public onChangeFreeRecipient(event: { id: string; name: string }[]): void {
    this.freeRecipientArray = event ?? [];
    this.getAmountRecipientsTitle();
  }

  public getTabItems(): void {
    this.searchTabs = [
      {
        header: this.translater.translate('recipients.users'),
        id: 'users',
        active: false,
        count: this.users.length,
      },
      {
        header: this.translater.translate('recipients.services'),
        id: 'services',
        active: false,
        count: this.servicesList.length,
      },
      {
        header: this.translater.translate('recipients.groups'),
        id: 'groups',
        active: false,
        count: this.groups.length,
      },
      {
        header: this.translater.translate('recipients.contacts'),
        id: 'contacts',
        active: false,
        count: this.contacts.length,
      },
      {
        header: this.translater.translate('recipients.freeRecipients'),
        id: 'free',
        active: false,
        count: null,
      },
    ];
    if (this.courrierType === 'S') {
      this.searchTabs[3].active = true;
      this.switchTabs({ value: this.searchTabs[3].id });
    } else {
      this.searchTabs[0].active = true;
      this.switchTabs({ value: this.searchTabs[0].id });
    }
  }

  switchTabs(e: { value: string }): void {
    this.userLoaded = false;
    this.filteredUsers = [];
    this.selectedTabs = e;
    e.value === 'contacts'
      ? (this.cols = [
        {
          field: 'name',
          header: this.translater.translate('name'),
          format: (value) => {
            if (value) {
              return value;
            } else {
              return '/';
            }
          },
        },
        {
          field: 'adresse',
          header: this.translater.translate('address'),
          format: (value) => {
            if (value) {
              return value;
            } else {
              return '/';
            }
          },
        },
      ])
      : '';
    this.filterBy(e);
  }

  filterBy(e): void {
    const value = e.value;

    this.filteredUsers = [];
    this.filteredContacts = [];
    this.filteredServices = [];
    this.filteredGroups = [];
    switch (value) {
      case 'contacts':
        this.filteredUsers = [];
        this.filteredGroups = [];
        this.filteredServices = [];
        this.filteredContacts = this.contacts.filter((x) => x.userId === null);
        this.filteredContacts.map((item) => {
          if (item.name) {
            item.name = item.name.trimStart();
          }
        });
        this.searchTabs[3].count = this.filteredContacts.length;
        break;
      case 'services':
        this.filteredUsers = [];
        this.filteredContacts = [];
        this.filteredGroups = [];
        this.filteredServices = this.servicesList;
        this.searchTabs[1].count = this.servicesList.length;

        break;
      case 'groups':
        this.filteredUsers = [];
        this.filteredContacts = [];
        this.filteredServices = [];
        this.filteredGroups = this.groups;
        this.filteredGroups.map((item) => {
          if (item.name) {
            item.name = item.name.trimStart();
          }
        });
        this.searchTabs[2].count = this.groups.length;

        break;
      case 'users':
        this.filteredUsers = [];
        this.filteredContacts = [];
        this.filteredGroups = [];
        this.filteredUsers = this.users;
        this.filteredUsers.map((item) => {
          if (item.name) {
            item.name = item.name.trimStart();
          }
        });
        this.searchTabs[0].count = this.users.length;
        break;
      case 'free':
        this.filteredUsers = [];
        break;
    }
    this.userLoaded = true;
  }

  /**
   * Add a free recipient
   * @param form data receive by the form
   */
  addRecipientFree(): void {
    if (this.freeRecipient !== '' && this.freeRecipient !== null) {
      const newRecipients = this.freeRecipient
        .split(';')
        .map((r) => r.trim())
        .filter((r) => r !== '')
        .map((r) => ({ id: r, name: r }));

      // nouvelle référence, jamais de mutation en place (push) sur le tableau existant
      this.freeRecipientPool = _.sortBy([...this.freeRecipientPool, ...newRecipients], 'name');
      this.freeRecipient = '';
    }
  }

  /**
   * Add selectedItems to mail Destinataire => send it to parent
   */
  addUsers(): void {
    const data: RecipientModalOnCloseDatas = {
      contactArray: this.contactArray,
      usersArray: this.usersArray,
      groupsArray: this.groupsArray,
      serviceArray: this.serviceArray,
      freeRecipientArray: this.freeRecipientArray,
    };
    sessionStorage.removeItem('showModalDestinataire');
    this.ref.close(data);
  }

  closeActionModal(): void {
    this.ref.close();
    sessionStorage.removeItem('showModalDestinataire');
  }

  openNewContact(): void {
    const ref = this.dialogService.open(ContactNewComponent, {
      styleClass: 'super-compos-modal-content',
      dismissableMask: false,
      width: '70vw',
      closable: false,
      showHeader: false,
      baseZIndex: 1000,
      data: {
        caller: 'linked',
        hideSwitch: false,
        companyMode: false,
      },
    });
    document.addEventListener('DOMContentLoaded', function () {
      const modalContent = document.querySelector('.p-dynamic-dialog');
      if (modalContent) {
        modalContent.setAttribute('draggable', 'true');
      }
    });

    ref.onClose.subscribe({
      next: (value) => {
        if (value) {
          this.filteredContacts.push(new LowInformationContact(value));
          this.getAmountRecipientsTitle();
        }
      },
    });
  }
}
